import { ApiGetRequest } from "../hooks/useApiCaller";

export const getUserId = async (
  getFn: ApiGetRequest<string>,
): Promise<string> => {
  return await getFn("/api/misc/user-id");
};
